// ---------------------------------------------------------------------------
// Dados institucionais da clínica. Edite aqui para atualizar o site inteiro.
// ---------------------------------------------------------------------------
export const SITE = {
  name: "RAMALIVE ODONTOLOGIA",
  shortName: "RAMALIVE",
  tagline: "Odontologia premium",
  // WhatsApp: apenas dígitos com DDI (55) + DDD (33) + número
  // Registro da clinica no CRO-MG (Empresa Prestadora de Assistencia Odontologica)
  epao: "EPAO 15284",
  whatsappNumber: "5533998282881",
  whatsappDisplay: "+55 33 99828-2881",
  email: "contato@ramalive.com.br",
  instagram: "https://www.instagram.com/ramaliveodontologia?stkn=MWYwZTRkbmszMHM3aA==",
  address: {
    line1: "R. Israel Pinheiro, 4210 - Bairro de Lourdes",
    line2: "Governador Valadares - MG, 35032-180",
    // Texto usado na busca do Google Maps (sem necessidade de chave de API)
    mapsQuery: "R. Israel Pinheiro, 4210 - Bairro de Lourdes, Governador Valadares - MG, 35032-180",
  },
  hours: [
    { day: "Segunda a sexta", time: "09:00 - 18:00" },
    { day: "Sábado", time: "Somente com agendamento" },
    { day: "Domingo", time: "Fechado" },
  ],
};

export const NAV_LINKS = [
  { id: "inicio", label: "Início" },
  { id: "sobre", label: "Sobre" },
  { id: "equipe", label: "Equipe" },
  { id: "servicos", label: "Serviços" },
  { id: "galeria", label: "Galeria" },
  { id: "agendamento", label: "Agendamento" },
  { id: "contato", label: "Contato" },
];

export const GALLERY_IMAGES = [
  { src: "/images/clinica-5651.jpg", alt: "Recepção da clínica com logotipo RAMALIVE na parede" },
  { src: "/images/clinica-5650.jpg", alt: "Consultório com cadeira odontológica e estante iluminada" },
  { src: "/images/clinica-5655.jpg", alt: "Consultório odontológico em tons neutros e iluminação indireta" },
  { src: "/images/clinica-5656.jpg", alt: "Ambiente de atendimento com mesa e espelho amplo" },
];

export const HERO_IMAGE = "/images/clinica-5656.jpg";
export const ABOUT_IMAGE = "/images/clinica-5651.jpg";
export const LOGO_IMAGE = "/images/logo-monograma.jpg";

// Horários disponíveis para a solicitação (a clínica confirma depois)
export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
];
